export default __webpack_public_path__ + "static/media/gen-helix.cdc04ed5.png";